import CheckIcon from '@mui/icons-material/Check';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Typography } from '@mui/material';

const LIST_SX = {
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'grey.300',
  overflow: 'hidden',
  boxShadow: '0 4px 16px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)',
};

export default function OnboardingSectionMenuList({ items, onItemClick }) {
  return (
    <Box sx={LIST_SX}>
      {items.map((item, index) => (
        <Box key={item.id}>
          {index > 0 && <Box sx={{ height: '1px', bgcolor: 'grey.300' }} />}
          <Box
            role={item.interactive ? 'button' : undefined}
            tabIndex={item.interactive ? 0 : undefined}
            onClick={() => item.interactive && onItemClick(item.id)}
            onKeyDown={(e) => {
              if (!item.interactive || (e.key !== 'Enter' && e.key !== ' ')) {
                return;
              }
              e.preventDefault();
              onItemClick(item.id);
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              py: 2.2,
              px: 2,
              bgcolor: 'background.paper',
              cursor: item.interactive ? 'pointer' : 'not-allowed',
              opacity: item.interactive ? 1 : 0.5,
              '&:hover': item.interactive ? { bgcolor: 'grey.50' } : {},
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: '50%',
                  border: '2px solid',
                  borderColor: item.completed ? 'success.main' : 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {item.completed ? (
                  <CheckIcon sx={{ fontSize: 18, color: 'success.main' }} />
                ) : (
                  <Typography
                    variant="body2"
                    fontWeight={400}
                    sx={{ color: 'primary.main' }}
                  >
                    {index + 1}
                  </Typography>
                )}
              </Box>
              <Typography variant="body1" fontWeight={400}>
                {item.label}
              </Typography>
            </Box>

            <ChevronRightIcon
              sx={{
                color: item.interactive ? 'primary.main' : 'grey.400',
                ml: 1,
              }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
